module.exports = __webpack_public_path__ + "img/acquisitions__image.c5600f85.jpg";